import script from "./ToothGroupServiceSelectorServicesList.vue?vue&type=script&setup=true&lang=js"
export * from "./ToothGroupServiceSelectorServicesList.vue?vue&type=script&setup=true&lang=js"

import "./ToothGroupServiceSelectorServicesList.vue?vue&type=style&index=0&id=1bcfbb45&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bcfbb45"]])

export default __exports__